import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import type { AdminHubSpotCompanySummary } from './useAdminCompanyExternalConnections';

export function useSearchAdminHubSpotCompanies(query: string | null) {
  const trimmedQuery = query?.trim();
  const params = new URLSearchParams({
    query: trimmedQuery ?? '',
    limit: '10',
  });
  const key = trimmedQuery
    ? `admin/external-connections/hubspot/companies/search?${params.toString()}`
    : null;
  const { data, error, isLoading } = useSWR<AdminHubSpotCompanySummary[]>(
    key,
    key ? SWRFetcher({ method: 'GET' }, undefined) : null
  );

  return { companies: data ?? [], error, isLoading: !!isLoading };
}
